module.exports = __webpack_public_path__ + "static/media/hta-main-logo.7b212baa.png";